export const SESSION_TOKEN_ITEM = "SESSION_TOKEN_ITEM"